export const PUBLIC_ROOM_SNAPSHOT_SCHEMA_VERSION = 1 as const;

export const MAX_PUBLIC_ROOM_PETS = 100;
export const MAX_PUBLIC_ROOM_HISTORY_POINTS = 90;
export const MAX_PUBLIC_ROOM_HISTORY_SOURCE_SCENES = 366;
export const MAX_PUBLIC_ROOM_SNAPSHOT_BYTES = 64 * 1024;

export const PUBLIC_ROOM_WEATHER_VALUES = [
  "clear",
  "party",
  "storm",
  "panic",
] as const;

export const SHARE_IDENTITY_VISIBILITY_VALUES = [
  "hidden",
  "ticker",
] as const;

export const SHARE_PERFORMANCE_VISIBILITY_VALUES = [
  "hidden",
  "direction",
  "roundedPercent",
] as const;

export const SHARE_ALLOCATION_VISIBILITY_VALUES = [
  "hidden",
  "bucket",
] as const;

export const SHARE_HISTORY_VISIBILITY_VALUES = [
  "none",
  "7d",
  "30d",
  "90d",
] as const;

export const PUBLIC_PERFORMANCE_DIRECTION_VALUES = [
  "down",
  "flat",
  "up",
  "unknown",
] as const;

export const PUBLIC_ALLOCATION_BUCKET_VALUES = [
  "tiny",
  "small",
  "medium",
  "large",
] as const;

export const PUBLIC_PET_PALETTE_VALUES = [
  "leaf",
  "sky",
  "coral",
  "honey",
  "violet",
  "mint",
  "berry",
  "apricot",
] as const;

export const PUBLIC_PET_PATTERN_VALUES = [
  "plain",
  "speckle",
  "stripe",
] as const;

export const PUBLIC_PET_HAT_VALUES = [
  "hat.cap.blue",
  "hat.party.purple",
  "hat.straw",
  "hat.ribbon.red",
  "hat.sprout",
] as const;

export const PUBLIC_ROOM_PET_ID_PATTERN = /^pet_[0-9a-f]{24}$/;
export const PUBLIC_ROOM_SEED_PATTERN = /^[A-Za-z0-9_-]{16,128}$/;
/** 32 random bytes encoded as unpadded base64url. Never publish this value. */
export const PRIVATE_PROJECTION_SEED_PATTERN = /^[A-Za-z0-9_-]{43}$/;
export const PUBLIC_ROOM_TICKER_PATTERN = /^[A-Z0-9][A-Z0-9.-]{0,19}$/;

export const MAX_PUBLIC_RENDERER_VERSION_LENGTH = 64;
export const MAX_PUBLIC_PET_NAME_LENGTH = 120;
export const MAX_PUBLIC_LOGO_KEY_LENGTH = 128;
